import {ICON_TYPES} from '../constants';

export const MailIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.25 0.583374H1.75C1.28587 0.583374 0.840752 0.767748 0.512563 1.09594C0.184374 1.42413 0 1.86925 0 2.33337L0 13.4167H14V2.33337C14 1.86925 13.8156 1.42413 13.4874 1.09594C13.1592 0.767748 12.7141 0.583374 12.25 0.583374ZM1.75 1.75004H12.25C12.4047 1.75004 12.5531 1.8115 12.6625 1.92089C12.7719 2.03029 12.8333 2.17866 12.8333 2.33337V2.72246L8.23783 7.31854C7.90908 7.64597 7.46399 7.82981 7 7.82981C6.53601 7.82981 6.09092 7.64597 5.76217 7.31854L1.16667 2.72246V2.33337C1.16667 2.17866 1.22812 2.03029 1.33752 1.92089C1.44692 1.8115 1.59529 1.75004 1.75 1.75004ZM1.16667 12.25V4.37504L4.93733 8.14337C5.48487 8.68952 6.22665 8.99623 7 8.99623C7.77335 8.99623 8.51513 8.68952 9.06267 8.14337L12.8333 4.37504V12.25H1.16667Z'
        fill='#141414'
      />
    </svg>
  );
};

MailIcon.iconType = ICON_TYPES.MAIL;
